import script from "./MyPublications.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPublications.vue?vue&type=script&setup=true&lang=js"

import "./MyPublications.vue?vue&type=style&index=0&id=2511a21c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2511a21c"]])

export default __exports__